import type { RouteRecordRaw } from "vue-router";
import { getAsyncComponentWrapper } from "../../composables";
import { router } from "@/services/router";
import {
  ROUTE_MAIN_NAME,
  ROUTE_ERROR_APP_LOAD_FAILED_NAME,
  ROUTE_ERROR_APP_LOAD_FAILED_PATH,
  ROUTE_ERROR_SERVICE_UNAVAILABLE_NAME,
  ROUTE_ERROR_SERVICE_UNAVAILABLE_PATH,
  ROUTE_ERROR_SESSION_EXPIRED_NAME,
  ROUTE_ERROR_SESSION_EXPIRED_PATH,
} from "../../constants";

const routes: RouteRecordRaw[] = [
  {
    path: "/",
    name: ROUTE_MAIN_NAME,
    component: getAsyncComponentWrapper(
      () => import("@/modules/app/components/MainComponent.vue")
    ),
  },
  {
    path: ROUTE_ERROR_SESSION_EXPIRED_PATH,
    name: ROUTE_ERROR_SESSION_EXPIRED_NAME,
    component: getAsyncComponentWrapper(
      () => import("@/modules/app/components/pages/SessionExpiredPage.vue")
    ),
  },
  {
    path: ROUTE_ERROR_SERVICE_UNAVAILABLE_PATH,
    name: ROUTE_ERROR_SERVICE_UNAVAILABLE_NAME,
    component: getAsyncComponentWrapper(
      () => import("@/modules/app/components/pages/ServiceUnavailablePage.vue")
    ),
  },
  {
    path: ROUTE_ERROR_APP_LOAD_FAILED_PATH,
    name: ROUTE_ERROR_APP_LOAD_FAILED_NAME,
    component: getAsyncComponentWrapper(
      () => import("@/modules/app/components/pages/AppLoadFailedPage.vue")
    ),
  },
  {
    path: "/:catchAll(.*)*",
    component: getAsyncComponentWrapper(
      () => import("@/modules/app/components/pages/ErrorNotFoundPage.vue")
    ),
  },
];

export default async () => {
  routes.forEach((route) => {
    router.addRoute(route);
  });
};
